module.exports= {
    "postbox-text": "Yorumunuzu buraya yazın (en az üç karakter)",
    "postbox-author": "İsim (zorunlu değil)",
    "postbox-email": "E-posta (zorunlu değil)",
    "postbox-website": "Web sitesi (zorunlu değil)",
    "postbox-preview": "Ön izleme",
    "postbox-edit": "Düzenle",
    "postbox-submit": "Gönder",
    "postbox-notification": "Yanıtlar için e-posta bildirimlerine abone ol",

    "num-comments": "Bir yorum\n{{ n }} yorum",
    "no-comments": "Henüz yorum yok",
    "atom-feed": "Atom akışı",

    "comment-reply": "Yanıtla",
    "comment-edit": "Düzenle",
    "comment-save": "Kaydet",
    "comment-delete": "Sil",
    "comment-confirm": "Onayla",
    "comment-close": "Kapat",
    "comment-cancel": "İptal",
    "comment-deleted": "Yorum silindi.",
    "comment-queued": "Yorumunuz yönetici onayını bekliyor.",
    "comment-anonymous": "Anonim",
    "comment-hidden": "{{ n }} gizli",

    "date-now": "şimdi",
    "date-minute": "bir dakika önce\n{{ n }} dakika önce",
    "date-hour": "bir saat önce\n{{ n }} saat önce",
    "date-day": "dün\n{{ n }} gün önce",
    "date-week": "geçen hafta\n{{ n }} hafta önce",
    "date-month": "geçen ay\n{{ n }} ay önce",
    "date-year": "geçen yıl\n{{ n }} yıl önce"
};
